import { getPlatform } from '@/shared/utils/config';
const platform = getPlatform();

export const CatalogDetailPage = defineAsyncComponent(() =>
  import(`./ui/${platform}/index.vue`).then(m => m.default),
);
